import { render, staticRenderFns } from "./coupon-t2.vue?vue&type=template&id=49ed0520&scoped=true&"
import script from "./coupon-t2.vue?vue&type=script&lang=js&"
export * from "./coupon-t2.vue?vue&type=script&lang=js&"
import style0 from "./coupon-t2.vue?vue&type=style&index=0&id=49ed0520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed0520",
  null
  
)

export default component.exports